<template>
   <Container :list="this.$nav6" title="院系专业" v-if="isMaxScreen">
    <div class="zyjj">
       <div class="breadcrumb">
                <router-link to="/" class="breadcrumb-item">
                  首页
                </router-link>
                -
                <span @click="$router.go(-1)" class="breadcrumb-item">
                   院系专业
                </span>
                -
                <span class="breadcrumb-item">{{obj.name}}</span>       
              </div>      
      <div class="zsxx_bottom">
        <h5 class="title"></h5>
        <div class="content" v-html="obj.intro"></div>
      </div>
    </div>
  </Container>

  <ZyxqH5 v-else />
</template>

<script>
import Container from '@/components/Container'
import ZyxqH5 from '@/views/app/zszy/zyjj/index'
export default {
  name: 'Zyjj',
  components: {Container, ZyxqH5},
  props: {},
  data() {
    return {
      obj: {},
      isMaxScreen: true
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getDepartment()
  },
  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      // console.log('外部', document.body.clientWidth)
      this.isMaxScreen = document.body.clientWidth > 850
      // console.log("this.isMaxScreen",this.isMaxScreen)
      // console.log(99999999999999999999999999999)
    })
  },
  methods: {
     async getDepartment() {    
      const data = await this.$get('/ow/major/' +  this.$route.query.id)
      this.obj = data
    },
  },
}
</script>

<style lang="scss" scoped>
  .zyjj {
    width: 890px;
    font-size: 16px;
    color: #333333;
    font-size: 14px;
      .title {
        font-size: 18px;
        text-align: center;
        margin-bottom: 2vw;
      }
      .content{
        font-size: 16px;
        text-indent: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        ::v-deep p {
          line-height: 2 !important;
        }
        ::v-deep img {
          width: 600px!important;
          height: 387px!important;
        }
      }
      .zsxx_bottom {
        display: flex;
        flex-wrap: wrap;
        .zszy_box {
          width: 282px;
          border: 1px solid #DBDBDB;
          margin-right: 14px;
          margin-bottom: 24px;
          text-indent: 12px;  
          cursor: pointer;      
          .zszy_box_hearder {
            display: flex;
            justify-content: space-between;
            background: #EDEDED;
            padding-right: 10px; 
            line-height: 48px;
            .zszy_hearder_right {
              
              color: #909399;
              span {
                margin-right: 2px;
              }
            }
          }
          
          .zszy_box_zylist {
            border-top: 1px solid #DBDBDB;
            line-height: 36px;                                
          }
        }
      }    
    }
</style>
